import email from '../assets/images/email.png';
import mobile from '../assets/images/mobile.png';
import cpp from '../assets/images/cpp.png';
import react from '../assets/images/react.png';
import flutter from '../assets/images/flutter.png';

import profile2 from '../assets/images/profile2.svg';
import profile3 from '../assets/images/profile3.svg';
import circle from '../assets/images/circle.svg';

import marvel from '../assets/images/marvel_logo.png'
import whatsapp from '../assets/images/whatsapp.webp'

import cap from '../assets/images/cap.webp'
import tony from '../assets/images/tony.webp'
import thor from '../assets/images/thor.webp'
import spidy from '../assets/images/spiderman.webp'
import panther from '../assets/images/blackpanther.webp'
import avengers from '../assets/images/avengers.webp'

export default {
  email,
  mobile,
  cpp,
  react,
  profile2,
  profile3,
  circle,
  marvel,
  cap,
  thor,
  tony,
  spidy,
  panther,
  avengers,
  whatsapp,
  flutter
};